




























import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { TemplateVariable } from "./types";

@Component
export default class NotificationTemplateVariables extends Vue {
  @Prop() useSimpleVariables?: boolean;

  @Getter("codebooks/notificationTemplateVariables")
  variables?: TemplateVariable[];
  @Action("codebooks/refreshNotificationTemplateVariables")
  refreshVariables?: () => Promise<void>;

  async created() {
    const promises = [];

    if ((this.variables?.length ?? 0) === 0 && this.refreshVariables) {
      promises.push(this.refreshVariables());
    }

    await Promise.all(promises);
  }

  variableFilter = "";

  get filteredVariables() {
    if (!this.variables) {
      return [];
    }

    let variables = this.variables;

    if (this.variableFilter)
      variables = this.variables
        .filter((x) => x.name.toLowerCase().includes(this.variableFilter.toLowerCase()));

    return variables;
  }

  dragStart(e: DragEvent, data: any) {
    e.dataTransfer?.setData("text", data.name);
  }
}
